import RechargeCooldownLabel from "../RechargeCooldownLabel";
import { RechargeCooldownError } from "@/store/rechargeCooldown";
import './index.less';
import React, { useCallback } from 'react';
import { useTranslationPlus } from '@/Core/i18n/useTranslationPlus';
import LoadingUI from '@/componentsUI/LoadingUI/LoadingUI';
import { useRechargeCryptoSelect, useWalletAll, useWalletRechargeCrypto } from '@/store/walletStore';
import FormUI from '@/componentsUI/Form';
import FromItemPlus from '@/components/FormItemPlus/FromItemPlus';
import InputWalletDropdown from '../../compoents/InputWalletDropdown';
import InputAmount from '../../compoents/InputAmount';
import { AmountDivisorConversion, AmountMultiplierConversion } from '@/Core/utils/currencyDealCenter';
import ButtonUI from '@/componentsUI/Button';
import useDialogManager from '@/utils/useDialogManager';
import { feedback } from '@/utils/feedback';
import { useRechargeCurrency } from "../useRechargeCurrency";
import { isRechargeAmountValid } from "../rechargeAmount";

const Crypto = () => {
  const prefixCls = 'recharge-crypto';
  const { t } = useTranslationPlus('Wallet');
  const { data } = useWalletAll();
  const [form] = FormUI.useForm();
  const { params, displayCurrencyType, changeRecharge } = useRechargeCurrency(data?.crypto, form);
  const { cryptoCfg, mutate, isValidating, error } = useRechargeCryptoSelect(params);
  const { trigger: triggerRechargeCrpto, isMutating: rechargeMutating, isRechargeBlocked } = useWalletRechargeCrypto();
  const { openDialogIFrame } = useDialogManager();
  const { t: tCommon } = useTranslationPlus();

  const validatorAmount = (va, cb) => {
    if (!isRechargeAmountValid(va?.value, cryptoCfg, displayCurrencyType, params?.currencyType)) {
      return cb(t('Wrong Amount'));
    }
  };
  const rechargeCrpto = useCallback(() => {
    if (isValidating || error || !cryptoCfg || rechargeMutating || isRechargeBlocked) return;
    form.validate().then((v) => {
      triggerRechargeCrpto({
        currencyType: params?.currencyType,
        money: AmountMultiplierConversion(v?.amount?.value, {
          currencyType: v?.walletType,
          serverCurrencyType: params?.currencyType,
        }),
        payCode: cryptoCfg?.payCode,
      })
        .then((res) => {
          if (res?.payUrl) {
            openDialogIFrame({
              title: t('Wallet_PayUrlTitle'),
              url: res?.payUrl,
              type: "pay",
            });
          } else {
            feedback.success(t('Payment request submitted successfully'));
          }
        })
        .catch((e) => {
          if (!(e instanceof RechargeCooldownError)) feedback.error(tCommon(e?.code));
        });
    }).catch(() => undefined);
  }, [cryptoCfg, form, triggerRechargeCrpto, openDialogIFrame, t, tCommon, params, isValidating, error, rechargeMutating, isRechargeBlocked]);

  return (
    <LoadingUI
      error={error}
      dataList={cryptoCfg}
      retryFunc={mutate}
      isLoading={isValidating}
    >
      <div className={prefixCls}>
        <FormUI
          disabled={isValidating}
          form={form}
          layout={'vertical'}
          autoComplete={'off'}
          className={`${prefixCls}-form`}
        >
          <FromItemPlus field={'walletType'} label={t('RechargeAmountTitle')}>
            <InputWalletDropdown
              options={data?.crypto}
              onChange={(_value, option) => {
                changeRecharge(option?._index);
              }}
            />
          </FromItemPlus>

          <FromItemPlus
            field={'amount'}
            label={
              <div>
                <span>{t('Desposit LimitAmount')}</span>
                {cryptoCfg?.decide === 2 && (
                  <span className={`${prefixCls}-limit`}>
                    {AmountDivisorConversion(Number(cryptoCfg?.min), {
                      currencyType: displayCurrencyType,
                    }) +
                      '~' +
                      AmountDivisorConversion(Number(cryptoCfg?.max), {
                        currencyType: displayCurrencyType,
                      })}
                  </span>
                )}
              </div>
            }
            required={true}
            rules={[{ required: true, message: t('Wrong Amount') }, { validator: validatorAmount }]}
          >
            <InputAmount currencyType={displayCurrencyType} placeholder={t('PlaceHolderInputAmount')} data={cryptoCfg} />
          </FromItemPlus>
        </FormUI>

        <ButtonUI
          className={`${prefixCls}-btn`}
          type="primary"
          disabled={!cryptoCfg || !!error || isValidating || rechargeMutating || isRechargeBlocked}
          loading={rechargeMutating}
          onClick={() => {
            rechargeCrpto();
          }}
        >
          <RechargeCooldownLabel>{t('Deposit')}</RechargeCooldownLabel>
        </ButtonUI>
      </div>
    </LoadingUI>
  );
};

export default Crypto;
